import { jsPDF } from "jspdf";
import autoTable, { RowInput } from "jspdf-autotable";
import { DocumentExportMetadata } from "../models/DocumentExportOptions";
import { drawPdfDocumentHeader } from "./PdfDocumentHeader";

export const drawPdfTable = (
  document: jsPDF,
  metadata: DocumentExportMetadata,
  headings: string[],
  rows: RowInput[],
  startY: number,
) => {
  autoTable(document, {
    startY,
    head: [headings],
    body: rows,
    theme: "grid",
    showHead: "everyPage",
    margin: { top: 22, right: 14, bottom: 20, left: 14 },
    styles: {
      fontSize: 8.5,
      cellPadding: 2.4,
      lineColor: [220, 226, 232],
      lineWidth: 0.2,
      textColor: [30, 41, 59],
      overflow: "linebreak",
    },
    headStyles: { fillColor: [3, 125, 65], textColor: [255, 255, 255], fontStyle: "bold" },
    alternateRowStyles: { fillColor: [248, 250, 252] },
    willDrawPage: (data) => {
      if (data.pageNumber > 1) drawPdfDocumentHeader(document, metadata, true);
    },
  });
  return (document as jsPDF & { lastAutoTable: { finalY: number } }).lastAutoTable.finalY;
};
